import { createChecklistHelpers } from '../utils/checklist-helper'

const {
  actionAddList,
  actionCheck,
  actionUncheck,
  selectRaw,
  select,
  selectLabels,
} = createChecklistHelpers('optChecks', 'opt')

/**
 * @param {string[]} listOfStrings
 * @returns {any} Updates to apply to case
 */
export const actionAddOptChecks = actionAddList

/**
 * @param {string} id
 * @returns {any} Updates to apply to case
 */
export const actionCheckOptCheck = actionCheck

/**
 * @param {string} id
 * @returns {any} Updates to apply to case
 */
export const actionUncheckOptCheck = actionUncheck

/**
 * @param {any} caseData
 * @returns {{
 *   [id: string]: {
 *     label: string
 *     order: number
 *     complete: boolean
 *   }
 * }}
 */
export const selectOptChecksRaw = selectRaw

/**
 * @param {any} caseData
 * @returns {Checklist}
 */
export const selectOptChecks = select

/**
 * @param {any} caseData
 * @returns {string[]}
 */
export const selectOptCheckLabels = selectLabels
